class LearnLibrary extends HTMLElement {
  connectedCallback() {
    this.dlg = this.querySelector('.ll-dialog');
    this.box = this.querySelector('.ll-dialog__content');
    this.chips = [...this.querySelectorAll('.ll__chip')];
    this.tiles = [...this.querySelectorAll('.ll-tile')];
    this.chips.forEach((c) => c.addEventListener('click', () => this.filter(c)));
    this.addEventListener('click', (e) => {
      const stop = e.target.closest('.ll-tile__stop');
      if (stop) { this.stopReels(); return; }
      const p = e.target.closest('[data-play]');
      if (p) { this.play(p); return; }
      const h = e.target.closest('[data-open]');
      if (h) this.open(h);
    });
    this.dlg.addEventListener('click', (e) => { if (e.target === this.dlg) this.dlg.close(); });
    this.querySelector('.ll-dialog__close').addEventListener('click', () => this.dlg.close());
    this.dlg.addEventListener('close', () => { this.box.innerHTML = ''; });
  }
  filter(chip) {
    const f = chip.dataset.filter;
    this.stopReels();
    this.chips.forEach((c) => {
      const on = c === chip;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    this.tiles.forEach((t) => {
      const cat = t.dataset.cat;
      t.hidden = !(f === 'all' || cat === 'all' || cat === f);
    });
  }
  stopReels() {
    this.querySelectorAll('.ll-tile__player').forEach((p) => p.remove());
  }
  play(btn) {
    const tile = btn.closest('.ll-tile');
    const tpl = document.getElementById(btn.dataset.play);
    if (!tile || !tpl) return;
    this.stopReels();
    const wrap = document.createElement('div');
    wrap.className = 'll-tile__player';
    wrap.appendChild(tpl.content.cloneNode(true));
    const x = document.createElement('button');
    x.type = 'button';
    x.className = 'll-tile__stop';
    x.setAttribute('aria-label', btn.dataset.stop || 'Close');
    x.textContent = '×';
    wrap.appendChild(x);
    tile.appendChild(wrap);
    const v = wrap.querySelector('video');
    if (v) { v.playsInline = true; v.play().catch(() => {}); }
  }
  open(btn) {
    const tpl = document.getElementById(btn.dataset.open);
    if (!tpl) return;
    this.stopReels();
    this.box.innerHTML = '';
    this.box.appendChild(tpl.content.cloneNode(true));
    this.querySelector('.ll-dialog__title').textContent = btn.dataset.title || '';
    this.dlg.showModal();
    this.box.scrollTop = 0;
    const car = this.box.querySelector('.ll-car');
    if (car) this.initCarousel(car);
  }
  initCarousel(car) {
    const track = car.querySelector('.ll-car__track');
    const slides = [...track.children];
    const prev = car.querySelector('.ll-car__prev');
    const next = car.querySelector('.ll-car__next');
    const count = car.querySelector('.ll-car__count');
    const update = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      count.textContent = (i + 1) + ' / ' + slides.length;
      prev.disabled = i <= 0;
      next.disabled = i >= slides.length - 1;
    };
    const go = (d) => track.scrollBy({ left: d * track.clientWidth, behavior: 'smooth' });
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    update();
  }
}
if (!customElements.get('learn-library')) customElements.define('learn-library', LearnLibrary);